import React from 'react';
import './TiposEstrutura.css';

const cards = [
  {
    id: 1,
    title: 'Estruturas Galvanizadas',
    titleColor: 'orange',
    image: '/index/image4.avif',
    description:
      'As estruturas galvanizadas recebem uma camada de zinco que protege contra corrosão, garantindo maior resistência e vida útil. São ideais para ambientes externos ou com alta umidade, como indústrias, centros logísticos e câmaras frias.',
  },
  {
    id: 2,
    title: 'Pintura Eletrostática',
    titleColor: 'orange',
    image: '/index/image5.avif',
    description:
      'A pintura eletrostática quando aplicada em mini e porta paletes, aumenta a vida útil, reduz a necessidade de manutenção e mantém um visual mais profissional, ideal para ambientes organizados e seguros.',
  },
  {
    id: 3,
    title: 'Porta Paletes',
    titleColor: 'white',
    image: '/index/image6.avif',
    description:
      'Os porta paletes são sistemas de armazenagem projetados para otimizar o espaço e facilitar o acesso às mercadorias. Ideais para centros logísticos e indústrias, permitem armazenar grandes volumes com segurança e praticidade.',
  },
  {
    id: 4,
    title: 'Mini Porta Paletes',
    titleColor: 'white',
    image: '/index/image7.avif',
    description:
      'Praticidade para cargas leves. Os mini porta paletes são ideais para armazenagem de cargas leves e manuseio manual, sem necessidade de empilhadeiras. Perfeitos para estoques menores, lojas e almoxarifados.',
  },
];

function TiposEstrutura() {
  return (
    <section className="tipos">
      <div className="tipos__container">
        {/* Cabeçalho */}
        <p className="tipos__subtitle">ESTRUTURAS QUE GERAM RESULTADOS</p>
        <h2 className="tipos__title">
          Tipos de <span className="tipos__title--highlight">Estruturas</span>
        </h2>
        <p className="tipos__description">
          Nossas soluções são projetadas para otimizar cada metro quadrado do seu armazém,
          elevando a produtividade operacional e garantindo a segurança total do seu estoque.
        </p>

        {/* Cards */}
        <div className="tipos__grid">
          {cards.map((card) => (
            <div key={card.id} className="tipos__card">
              {/* Imagem placeholder — será substituída depois */}
              <div className="tipos__card-image">
                {card.image ? (
                  <img src={card.image} alt={card.title} />
                ) : (
                  <div className="tipos__card-placeholder" />
                )}
              </div>

              {/* Conteúdo */}
              <div className="tipos__card-body">
                <h3
                  className={`tipos__card-title tipos__card-title--${card.titleColor}`}
                >
                  {card.title}
                </h3>
                <p className="tipos__card-text">{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="tipos__cta">
        <p className="tipos__cta-text">Precisa de um projeto personalizado?</p>
        <a 
          href="https://wa.me/5562991563162?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20para%20estruturas." 
          target="_blank" 
          rel="noopener noreferrer"
          className="tipos__cta-btn"
        >
          SOLICITAR ORÇAMENTO
        </a>
      </div>
    </section>
  );
}

export default TiposEstrutura;
